import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=1396cff0&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=1396cff0&prod&lang=scss&scoped=true"
import style1 from "./Templates.vue?vue&type=style&index=1&id=1396cff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396cff0",
  null
  
)

export default component.exports